const initialState = {
    eventData: undefined,
    tabValue: undefined,
    users: undefined,
    user: undefined,
    followingData: [{}],
    allfollowerdata:[{}],
    allUserData:[]

}

export function Event(state = initialState, action) {

    switch (action.type) {
        case 'SET_EVENT_DATA':
            return {
                ...state,
                eventData: action.eventData
            }
        case 'SET_BOTTOM_TAB':
            return {
                ...state,
                tabValue: action.tabValue
            }
        case 'SET_USERS':
            return {
                ...state,
                users: action.users
            }
        case 'SET_USER':
            return {
                ...state,
                user: action.user
            }
        case 'FOLLOWING_DATA':
            return {
                ...state,
                followingData: action.followingData,
            }
        case 'FOLLOWER_DATA':
            return {
                ...state,
                allfollowerdata: action.allfollowerdata,
            }
        case 'USER_DATA':
                return {
                    ...state,
                    allUserData: action.allUserData,
                }
        default:
            return state
    }
}